import {Component} from '@angular/core';

@Component({
    selector: 'mm-profile-learner-missing',
    templateUrl: './profile-learner-missing.component.html',
    styleUrls: ['./profile-learner-missing.component.scss'],
    standalone: false
})
export class ProfileLearnerMissingComponent {

    // A reload runs the Teams initialization and every tab request again, the same as reopening the tab.
    public retry = async (): Promise<void> => {
        window.location.reload();
        return Promise.resolve();
    };
}
